import React, { SyntheticEvent, useEffect, useState } from 'react';

import filtersStyles from '../../Filters.module.scss';
import { CloseLight, Action } from 'esa-ui-library';

import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import useFilters from '../../../../../common/hooks/useFilters';

const CategoriesFilter = (): JSX.Element => {
	const [{ gameCategories, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);
		onFilter([{ name: 'category_ids', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();
		onFilter([{ name: 'category_ids', value: '' }]);
	};

	const onSelectAll = () => {
		if (!gameCategories || !gameCategories.length) return;
		const allValues = gameCategories.map((c: PropertyType) => c.value).join(',');
		setFiltersOptions(selectPreselectedOptions(gameCategories, allValues));
		onFilter([{ name: 'category_ids', value: allValues }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (gameCategories) {
			setFiltersOptions(cloneDeep(gameCategories));
		}
	}, [gameCategories]);

	useEffect(() => {
		const filter = find(filters, ['name', 'category_ids'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(gameCategories, filter));
	}, [filters]);

	return (
		<Action
			label='Categories'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='categories-filter'
		>
			<FilterDropdown
				data={filterOptions}
				onChange={onFilterChange}
				isSearchable
				enableSelectAll
				onSelectAll={onSelectAll}
				selectAllLabel='Select All'
			/>
		</Action>
	);
};

export { CategoriesFilter };
